import { SearchItem } from "../types/search-engine.types";

class SearchRegistry {
    private items: SearchItem[] = [];

    register(items: SearchItem[]) {
        this.items.push(...items);
    }

    getAll() {
        return this.items;
    }
}

export const searchRegistry = new SearchRegistry();
